<template>
    <div>

        <config-main-title>
            {{ title }}
        </config-main-title>

        <div v-if="!em_edicao && service">

            <div class="row mb-3">
                <div class="col col-12 col-md-6">
                    <az-input icon="fas fa-search" v-model="search">
                        <template v-slot:buttonposb v-if="cadastro == 'amostra-material'">
                            <importacao service="amostra_materiais" @refresh="load()" />
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir {{ short_title }}
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length ) && service">
            <az-empty-state 
                :msg="'Nenhum ' + this.short_title.toLowerCase() + ' identificado.'" 
                icon="fas fa-search"
                :action="'Incluir ' + this.short_title" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length && service">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ short_title }}
                            {{ item && item.novo ? '(Novo)' : '' }}
                            <span class="badge badge-secondary ml-2" v-if="model && campo_id && item && item[campo_id]">
                                #{{ item[campo_id] }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item && metadados">
                        <div class="row">
                            <div class="col" v-for="(campo, ic) in metadados.edit_fields" :key="ic">
                                <az-input
                                    :label="campo.display"
                                    :validate="validate"
                                    v-model="item[campo.name]" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button v-if="model && campo_id && item" :model="model" :id="item[campo_id]" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Importacao from '../shared/Importacao.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            metadados: null, 
            model: "",
            campo_id: "",
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        Importacao
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                })
                .sort((a, b) => { 
                    return a.search > b.search ? 1 : -1 ;
                }) : null;
        }
    },

    methods: { 
        incluir () { 
            this.validate = false;

            let item = {
                id_material: null, 
                st_material: "", 
                material_unidade: { 
                    fl_ativo: true, 
                }
            };

            this.editar (item);
        },
        load () { 
            this.$store.commit('loading', true);

            let query = { q: [
                { 
                    name: this.service + '.index',
                    id: 'lista',
                    parms: { 
                        cadastro: true, 
                    }
                },
                { 
                    name: this.service + '.create',
                    id: 'metadados',
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.lista.status == 200 ) { 
                        this.dados = res.data.lista.data;
                    }

                    if ( res.data.metadados.status == 200 ) { 
                        this.metadados = res.data.metadados.data;
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });
        },
        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);
            $('#edicaoModal').modal('show');
        },
        atualizar () { 

            this.$util.atualizar(this, { 
                service: this.service,
                dados: { 
                    ...this.item,
                    cadastro: true, 
                },
                modal: 'edicaoModal',
                toast: true, 
                reload: true,
            });

            /*

            this.validate = true;

            this.$nextTick (() => { 

                let invalids = $('.invalid');

                if ( invalids.length ) { 
                   
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Verificar preenchimento dos campos.",
                        life: 3000
                    });

                } else { 

                    this.$store.commit('loading', true);

                    let query = { q: [ 
                        { 
                            name: this.service + '.store',
                            id: 'atualizar',
                            parms: { 
                                ...this.item,
                                cadastro: true, 
                            }
                        }
                    ]};
                    
                    this.axios.post('/aql', query)
                        .then (res => { 
                            if ( res.data.atualizar.status == 200 ) { 
                                $('#edicaoModal').modal('hide');
                                this.load();

                                this.$toast.add({
                                        severity: "success",
                                        summary: "Atenção",
                                        detail: "Cadastro atualizado.",
                                        life: 3000
                                    });
                            }
                        })
                        .finally(() => { 
                            this.$store.commit('loading', false);
                        });

                }
               
            });
            */

        },
        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$store.commit('loading', true);

            let query = { q: [ 
                { 
                    name: this.service + '.toggle',
                    id: 'toggle',
                    parms: { 
                        ...item,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.toggle.status == 200 ) { 
                        //
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () { 
        switch (this.cadastro) {
            case 'bloqueio-motivos':
                this.service = 'bloqueio_motivos';
                this.title = 'Motivo de Bloqueio de Agendas';
                this.short_title = 'Motivo';
                this.model = 'bloqueioMotivo';
                this.campo_id = 'id_bloqueio_motivo';
                break;

            case 'motivos-glosa':
                this.service = 'motivos_glosa';
                this.title = 'Motivos de Pendências de Guia';
                this.short_title = 'Motivo';
                this.model = 'motivoGlosa';
                this.campo_id = 'id_motivo_glosa';
                break;

            case 'amostra-material':
                this.service = 'amostra_materiais';
                this.title = 'Materiais de Amostra';
                this.short_title = 'Material de Amostra';
                this.model = 'amostraMaterial';
                this.campo_id = 'id_amostra_material';
                break;

            default:
                this.service = '';
                this.title = 'Endereço Inválido!!!';
                this.short_title = '???';
                break;
        }

        if ( this.service )
            this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: this.title, method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>